import { useParams } from 'react-router-dom';

import { useGetProductItemModules } from 'pages/product-full-view/components/product-new-detail-view/queries';

import {
  FormItemBoolean,
  FormItemSelectEnum,
} from 'pages/product-full-view/shared/components';

import {
  CATEGORY_RIFLE,
  CATEGORY_SHOTGUN,
} from 'pages/product-full-view/components/product-new-detail-view/constants';

export const FormItemChokeSystem = (props) => {
  const { id: productId } = useParams();

  const { property, name } = props;

  const { basicInformationData } = useGetProductItemModules(productId);

  const isShotgunCategory =
    Boolean(basicInformationData?.SubCategory) &&
    basicInformationData?.SubCategory?.toLowerCase() ===
      CATEGORY_SHOTGUN?.toLowerCase();

  if (isShotgunCategory) {
    return (
      <FormItemBoolean name={name} property={property} labelCol={{ span: 6 }} />
    );
  }
  return null;
};

export const FormItemTwistRate = (props) => {
  const { id: productId } = useParams();

  const { property, nameFormItem, propertyEnums } = props;

  const { basicInformationData } = useGetProductItemModules(productId);

  const subCategory = basicInformationData?.SubCategory?.toLowerCase();

  const isShowField =
    subCategory === CATEGORY_SHOTGUN?.toLowerCase() ||
    subCategory === CATEGORY_RIFLE?.toLowerCase();

  if (isShowField) {
    return (
      <FormItemSelectEnum
        property={property}
        nameFormItem={nameFormItem}
        propertyEnums={propertyEnums}
        labelCol={{ span: 6 }}
      />
    );
  }
  return null;
};

export const FormItemChoke = (props) => {
  const { id: productId } = useParams();

  const { property, nameFormItem, propertyEnums } = props;

  const { basicInformationData } = useGetProductItemModules(productId);

  const subCategory = basicInformationData?.SubCategory?.toLowerCase();

  const isShowField = subCategory === CATEGORY_SHOTGUN?.toLowerCase();

  if (isShowField) {
    return (
      <FormItemSelectEnum
        property={property}
        nameFormItem={nameFormItem}
        propertyEnums={propertyEnums}
        labelCol={{ span: 6 }}
      />
    );
  }
  return null;
};

export const FormItemRifledBarrel = (props) => {
  const { id: productId } = useParams();

  const { property, nameFormItem, propertyEnums } = props;

  const { basicInformationData } = useGetProductItemModules(productId);

  const subCategory = basicInformationData?.SubCategory?.toLowerCase();

  const isShowField = subCategory === CATEGORY_SHOTGUN?.toLowerCase();

  if (isShowField) {
    return (
      <FormItemSelectEnum
        property={property}
        nameFormItem={nameFormItem}
        propertyEnums={propertyEnums}
        labelCol={{ span: 6 }}
      />
    );
  }
  return null;
};
